/* eslint-disable @typescript-eslint/no-unused-vars */
import { createAsyncThunk } from "@reduxjs/toolkit"
import { getFacturasByIdSimple } from "api/Factura.service"
import AlbaranService from "common/services/AlbaranService"
import FacturaRecurrenteService from "common/services/FacturaRecurrenteService"
import FacturaService from "common/services/FacturaService"
import PedidoService from "common/services/PedidoService"
import PresupuestoService from "common/services/PresupuestoService"
import { estadoRevisionHasMotivo } from "common/utils/constants"
import notification from "common/utils/notification"
import i18next from "i18next"

export const changeEstadoFactura = createAsyncThunk(
  "documentos/changeEstadoFactura",
  async (
    {
      // @ts-expect-error TS(2339): Property 'documentoId' does not exist on type 'voi...
      documentoId,
      // @ts-expect-error TS(2339): Property 'estadoRevisionDocumento' does not exist ...
      estadoRevisionDocumento,
      // @ts-expect-error TS(2339): Property 'motivo' does not exist on type 'void'.
      motivo,
      // @ts-expect-error TS(2339): Property 'documentoSelected' does not exist on typ...
      documentoSelected,
    },
    // @ts-expect-error TS(6133): 'thunkApi' is declared but its value is never read...
    thunkApi
  ) => {
    const { estadoCesion } = documentoSelected

    if (estadoCesion === 0) {
      const bodyToSend = {}
      if (estadoRevisionDocumento === 2) {
        // @ts-expect-error TS(2339): Property 'aceptaPolitica' does not exist on type '...
        bodyToSend.aceptaPolitica = true
        // @ts-expect-error TS(2339): Property 'estadoCesion' does not exist on type '{}...
        bodyToSend.estadoCesion = estadoRevisionDocumento
      }
      if (estadoRevisionDocumento === 3) {
        // @ts-expect-error TS(2339): Property 'estadoCesion' does not exist on type '{}...
        bodyToSend.estadoCesion = estadoRevisionDocumento
        // @ts-expect-error TS(2339): Property 'motivo' does not exist on type '{}'.
        bodyToSend.motivo =
          estadoRevisionHasMotivo(estadoRevisionDocumento) && motivo.length
            ? motivo.length
            : null
      }
      await FacturaService.changeCesionFactura(bodyToSend, documentoId)
    } else {
      await FacturaService.changeEstadoFactura({
        documentoId,
        estadoRevisionDocumento,
        motivo: estadoRevisionHasMotivo(estadoRevisionDocumento)
          ? motivo
          : null,
      })
    }

    notification.success({
      body: `${i18next.t("notification.statusInvoceUpdate")}`,
    })
  }
)

export const changeEstadoPresupuesto = createAsyncThunk(
  "documentos/changeEstadoPresupuesto",
  // @ts-expect-error TS(2339): Property 'documentoId' does not exist on type 'voi...
  async ({ documentoId, estadoRevisionDocumento, motivo }, thunkApi) => {
    await PresupuestoService.changeEstado({
      documentoId,
      estadoRevisionDocumento,
      motivo: estadoRevisionHasMotivo(estadoRevisionDocumento) ? motivo : null,
    })

    notification.success({
      body: `${i18next.t("notification.statusBurgetUpdate")}`,
    })
  }
)

export const changeEstadoPedido = createAsyncThunk(
  "documentos/changeEstadoPedido",
  // @ts-expect-error TS(2339): Property 'documentoId' does not exist on type 'voi...
  async ({ documentoId, estadoRevisionDocumento, motivo }, thunkApi) => {
    await PedidoService.changeEstado({
      documentoId,
      estadoRevisionDocumento,
      motivo: estadoRevisionHasMotivo(estadoRevisionDocumento) ? motivo : null,
    })

    notification.success({
      body: `${i18next.t("notification.statusOrderUpdate")}`,
    })
  }
)

export const changeEstadoAlbaran = createAsyncThunk(
  "documentos/changeEstadoAlbaran",
  // @ts-expect-error TS(2339): Property 'documentoId' does not exist on type 'voi...
  async ({ documentoId, estadoRevisionDocumento, motivo }, thunkApi) => {
    await AlbaranService.changeEstado({
      documentoId,
      estadoRevisionDocumento,
      motivo: estadoRevisionHasMotivo(estadoRevisionDocumento) ? motivo : null,
    })

    notification.success({
      body: `${i18next.t("notification.statusDeliveyUpdate")}`,
    })
  }
)

export const changeMultiplePresupuestosEstados = createAsyncThunk(
  "documentos/changeMutiplePresupuestosEstados",
  // @ts-expect-error TS(2339): Property 'documentosId' does not exist on type 'vo...
  async ({ documentosId, estadoRevisionDocumento, motivo }, thunkApi) => {
    await PresupuestoService.changeMultipleEstados({
      documentosId,
      estadoRevisionDocumento,
      motivo: estadoRevisionHasMotivo(estadoRevisionDocumento) ? motivo : null,
    })

    notification.success({
      body: `${i18next.t("notification.statusBurgetSUpdate")}`,
    })
  }
)

export const changeMultipleFacturasEstados = createAsyncThunk(
  "documentos/changeMutipleFacturasEstados",
  async (
    // @ts-expect-error TS(2339): Property 'documentosId' does not exist on type 'vo...
    { documentosId, estadoRevisionDocumento, motivo, aceptarPoliticaValidada },
    // @ts-expect-error TS(6133): 'thunkApi' is declared but its value is never read...
    thunkApi
  ) => {
    await FacturaService.changeMultipleEstados({
      documentosId,
      estadoRevisionDocumento,
      motivo: estadoRevisionHasMotivo(estadoRevisionDocumento) ? motivo : null,
      aceptarPoliticaValidada,
    })

    notification.success({
      body: `${i18next.t("notification.statusInvoceSUpdate")}`,
    })
  }
)

export const changeMultiplePedidosEstados = createAsyncThunk(
  "documentos/changeMutiplePedidosEstados",
  // @ts-expect-error TS(2339): Property 'documentosId' does not exist on type 'vo...
  async ({ documentosId, estadoRevisionDocumento, motivo }, thunkApi) => {
    await PedidoService.changeMultipleEstados({
      documentosId,
      estadoRevisionDocumento,
      motivo: estadoRevisionHasMotivo(estadoRevisionDocumento) ? motivo : null,
    })

    notification.success({
      body: `${i18next.t("notification.statusOrderSUpdate")}`,
    })
  }
)

export const changeMultipleAlbaranesEstados = createAsyncThunk(
  "documentos/changeMutipleAlbaranesEstados",
  // @ts-expect-error TS(2339): Property 'documentosId' does not exist on type 'vo...
  async ({ documentosId, estadoRevisionDocumento, motivo }, thunkApi) => {
    await AlbaranService.changeMultipleEstados({
      documentosId,
      estadoRevisionDocumento,
      motivo: estadoRevisionHasMotivo(estadoRevisionDocumento) ? motivo : null,
    })

    notification.success({
      body: `${i18next.t("notification.statusDeliveySUpdate")}`,
    })
  }
)

export const getDocumentosPendientesValidacion = createAsyncThunk(
  "documentos/validaciones",
  // @ts-expect-error TS(2339): Property 'service' does not exist on type 'void'.
  async ({ service, queryParams }, thunkApi) => {
    const { data } = await service(queryParams)
    return data
  }
)

/**
 * Obtiene un documento pendiente de validación por ID.
 * @async
 * @function getDocumentoPendienteValidacionById
 * @param {object} [params] - Parámetros de la función.
 * @param {Function} params.service - Función de servicio para obtener el documento.
 * @param {string} params.id - ID del documento que se desea obtener.
 */
export const getDocumentoPendienteValidacionById = createAsyncThunk(
  "documentos/validacion",
  // @ts-expect-error TS(2339): Property 'service' does not exist on type 'void'.
  async ({ service, id }, { rejectWithValue }) => {
    const { data } = await service(id)
    return data
  }
)

export const getFacturasRecurrentes = createAsyncThunk(
  "documentos/getFacturasRecurrentes",
  // @ts-expect-error TS(2339): Property 'queryParams' does not exist on type 'voi...
  async ({ queryParams, queryState }, thunkApi) => {
    const { data } = await FacturaRecurrenteService.getFacturasRecurrentes(
      queryParams,
      // @ts-expect-error TS(2339): Property 'queryState' does not exist on type 'vo...
      queryState
    )

    return data
  }
)
export const getFacturaRecurrenteById = createAsyncThunk(
  "documentos/getFacturasRecurrentesById",
  // @ts-expect-error TS(6133): 'thunkApi' is declared but its value is never read...
  async (id, thunkApi) => {
    const { data } = await FacturaRecurrenteService.getById(id)
    return data
  }
)

export const getFacturasRecurrentesHistorico = createAsyncThunk(
  "documentos/getFacturasRecurrentesHistorico",
  // @ts-expect-error TS(2339): Property 'id' does not exist on type 'void'.
  async ({ id, query }, thunkApi) => {
    const { data } =
      await FacturaRecurrenteService.getFacturasRecurrentesHistoricas(id, query)

    return data
  }
)
export const getFactura = createAsyncThunk(
  "documentos/getFactura",
  // @ts-expect-error TS(6133): 'thunkApi' is declared but its value is never read...
  async (id, thunkApi) => {
    // @ts-expect-error TS(2345): Argument of type 'void' is not assignable to param...
    const data = await getFacturasByIdSimple(id)
    return data
  }
)

export const getFlujosTesoreriaFromFacturas = createAsyncThunk(
  "documentos/facturas/flujos-tesoreria",
  // @ts-expect-error TS(6133): 'thunkApi' is declared but its value is never read...
  async (id, thunkApi) => {
    const { data } = await FacturaService.getFlujosTesoreriaFromFacturas(id)
    return data
  }
)
